import { useEffect, useState } from "react";
import { useHistory } from "react-router";
// Components
import BannerOne from "../../../components/BannerOne";

// Constants
import { TITLE, ALL_DYNA_CONTACT_LIST, ALL_PARTNER_CONTACT_LIST, ALL_EVENTS_LIST, ALL_ITEMS_LIST, ALL_TOOLS_LIST, ABOVE_TITLE, ALL_BANNERS} from "./WelcomeDXCConstants";
import { BUTTON_NAME, BUTTON_LINK} from "./WelcomeDXCConstants";

// Images
import homepageBanner from '../../../assets/img/partnerPortal/homepage.png';
import dxc from '../../../assets/img/partnerPortal/welcomeDXC/dxc_logo.png';
import checkmark from '../../../assets/img/partnerPortal/welcomeAccenture/checkmark-small.svg';
import demo_banner from '../../../assets/img/partnerPortal/welcomePage/demoImg.png';

// import firstImage from '../../assets/img/partnerProgram/sectionImage.png';
// Scss
import '../../../assets/css/partnerProgram.scss';
import '../../../assets/css/partnerPortal/welcome.scss';

// actions
import * as partnerPortalAction from "../../../actions/partnerPortal/PartnerPortalAction";

import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import Image from "react-bootstrap/Image";
import NewsSection from "../../../components/NewsSection";
import Title from "../../../components/Title";
import ButtonOne from "../../../components/ButtonOne";
import ContactSection from "../../../components/ContactSection";
import ItemSection from "../../../components/ItemSection";
import PartnerCertificationsDTO from "../../../models/PartnerCertificationsDTO";
import VidyardPlayer from "../../../utils/VidyardPlayer";
import { Carousel } from "react-bootstrap";


function WelcomeDXC() {

  let history = useHistory();
  const [certificationList, setCertificationList] = useState<Array<PartnerCertificationsDTO>>();
  const [buttonName, setButtonName] = useState("Show more");

  useEffect(() => {
    canYouHaveAccess();
    //getCertification();
  }, []);


  return (
    <>
      <div>

        <BannerOne bannerImage={homepageBanner} title={TITLE} logo2={dxc} aboveTitle={ABOVE_TITLE} logoWidth={"15%"} buttonName={BUTTON_NAME} buttonLink={BUTTON_LINK} targetFirstButton="_parent" marginTop={"addMarginTop2"} />
        <Container className="mt-5">

            <div className="welcomeBanner mb-5">
                <div className="videoStyle"  > 
                    <VidyardPlayer uuid="Dikmm4zNvfD5fS2YQhNcK7" type="lightbox"/>
                </div>
                <div className="welcomeQuote">
                    <div className="quote">"With our expanded partnership we are now using Dynatrace for infrastructure management which allows us 
                            to bring industry-leading observability to our over 560 customers running on Platform X."
                    </div>
                    <div className="quoteSign">
                        <div className="quoteSignatureGeneral fontWeight700">Terese Pate</div>
                        <div className="quoteSignatureGeneral fontWeight400">Head of Product, DXC Platform X, DXC Technology</div>
                    </div>
                </div>
            </div>

            <Row>
                <Col xs={12} sm={12} md={12} lg={8} className="mb-5">
                    <Carousel>
                        {ALL_BANNERS.map(b => <Carousel.Item>
                            <a href={b.link} target={b.target}>
                                <Image src={b.image} width={b.width} />
                            </a>
                        </Carousel.Item>)}
                    </Carousel>

                    <div>
                        <Title className={"mt-5"} title={"Welcome to the Dynatrace Portal"}/>
                        <div className="welcomeMessageSection mt-3">
                            <div className="contactGeneral fontWeight400">The customized portal is designed to assist DXC in their enablement journey 
                                within our partnership. As you enter the portal, it provides DXC team members the following value:
                            </div>
                            <div className="welcomeList">
                                <div className="welcomeListRow">
                                    <img src={checkmark} />
                                    <div className="contactGeneral fontWeight400">Understand the market space Dynatrace resides in, the client challenges we help 
                                        resolve, and the joint value the long standing DXC / Dynatrace partnership brings to market.
                                    </div>
                                </div>
                                <div className="welcomeListRow">
                                    <img src={checkmark} />
                                    <div className="contactGeneral fontWeight400">Provide you an asset library of partnership specific content, 
                                        joint win stories, positioning decks, and enablement tracks to help you support your client projects and services.
                                    </div>
                                </div>
                                <div className="welcomeListRow">
                                    <img src={checkmark} />
                                    <div className="contactGeneral fontWeight400">Outlines key contacts of the global partnership, to help you connect 
                                        with the right teams in real time.
                                    </div>
                                </div>
                                <div className="welcomeListRow">
                                    <img src={checkmark} />
                                    <div className="contactGeneral fontWeight400">Register new opportunities to team up on, providing DXC 
                                        protection and assurance of the deals.
                                    </div>
                                </div>
                                
                            </div>
                            <div className="contactGeneral fontWeight400">We look forward to working with you.</div>
                        </div>
                    </div>

                    <div>
                        <Title className={"mt-5"} title={"Recent DXC Wins"}/>
                        <ItemSection itemList={ALL_ITEMS_LIST}/>
                    </div>

                    <div>
                        <Title className={"mt-5"} title={"Partner sales tools"}/>
                        <ItemSection itemList={ALL_TOOLS_LIST}/>
                    </div>

                    {/* <div>
                        <Title className={"mt-5"} title={"Congratulations to our latest experts"}/>
                        {(certificationList == undefined) ? "" : <ExpertsSection partnerCertificationList={certificationList} />}

                    </div> */}
                    
                    <div>
                        <Title className={"mt-5"} title={"Demo"}/>
                        <div className="cardDemo mt-3">
                            <div className="demoContent">
                                <Title  withoutLine={true} classNameText="fontSize18" title={<div>Access our demo<br></br> environment to deliver the<br></br> best presentations to your prospects</div>}/>
                                <ButtonOne text={"Learn more"} classNameOfA={"wid45"} className={"pad7"}  link={"https://demo.live.dynatrace.com/"} withoutIcon={true} />   
                            </div>
                            <img className="demoImgCard" src={demo_banner} width="50%" />
                        </div>
                    </div>
                </Col>
                {/* SECOND COLUMN */}
                <Col  xs={12} sm={12} md={12} lg={4}>
                    <div className="frameOne">
                        <Title title={"Dynatrace Partner Contacts"} className="width100"/>
                        <ContactSection contactList={ALL_DYNA_CONTACT_LIST}/>
                    </div>
                    <div className="frameOne">
                        <Title title={"DXC Partner Contacts"} className="width100"/>
                        <ContactSection contactList={ALL_PARTNER_CONTACT_LIST}/>
                    </div>
                    <div className="frameOne">
                        <Title title={"News, webinars & featured events"} className="width100"/>
                        <NewsSection newsList={ALL_EVENTS_LIST} buttonName={buttonName} action={ShowMoreOrLessEvents}/>
                    </div>
                </Col>
            </Row>
          
        </Container>

      </div >
    </>
  );

    function canYouHaveAccess() {
    try {
        if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        history.push('/not-found');
        }
    } catch (err) {
        

    }
    };

    function ShowMoreOrLessEvents() {
        console.log("here");
        setButtonName(buttonName === "Show more" ? "Show less" : "Show more");
        ALL_EVENTS_LIST.forEach(e => e.show = !e.show);
    };

  
    async function getCertification() {
        partnerPortalAction.getPartnerCertifications("DXC", 6).then(response => {
            setCertificationList(response.data);
        }).catch(err => {
            console.error('certifications not fetch!', err);
        });
    }

}

export default WelcomeDXC;

